exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-tooltip {display: contents !important\n}\n.v-menu {display: inline-block !important;\n}\n.row {margin: 0 !important;\n}\n.v-navigation-drawer .v-list {background: inherit !important;\n}\n.WatchBox-conversation .txtChat {width: calc(100% - 24px) !important;\n}\n.v-btn--bottom {bottom: 16px;\n}\n.sessionTimer {\n  text-align: center;\n  font-size: 0.8em;\n  bottom: 40px;\n  position: absolute;\n  width: 100%;\n  color:rgb(197, 197, 197)\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Dash.vue
// module id = jpfy
// module chunks = 1